import { IFile } from '@/models';

export function validateFile(
  file: IFile,
  type = 'image',
  size = 30,
): string | boolean {
  // if file type is not 'image/*' and file size not less than 30kb
  // return error on file form field
  if (!file.mimeType.includes(type)) {
    return `file should be of type ${type}`;
  }

  if (file.size > size * 1024) {
    return `file size should be less than ${size}KB`;
  }

  return true;
}
